// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"fo-z","breadcrumbForward":"go-z","breadcrumbBack":"ho-z","selected":"io-z"};